<div class="c-form--d c-form__section" [formGroup]="formGroup">
  <p500-ui-select-field
    [data]="programTypeOptions"
    i18n-label="@@common.program_type"
    label="Program Type"
    formControlName="program_type"
  ></p500-ui-select-field>
</div>
<div class="c-form--d c-form__section d-flex">
  <span class="fw-bold mr-10" i18n="@@common.add_models">Add Models</span>
  <button p500-ui-circled-button size="small" color="primary" type="button" (click)="addControl()">
    <p500-ui-icon name="plus"></p500-ui-icon>
  </button>
</div>
<ng-container *ngTemplateOutlet="modelsTpl; context: { $implicit: 0 }"></ng-container>
<div *ngFor="let controls of formGroup.controls.models.controls | slice : 1; index as i">
  <ng-container *ngTemplateOutlet="modelsTpl; context: { $implicit: i + 1 }"></ng-container>
</div>
<ng-template #modelsTpl let-index>
  <ng-container [formGroup]="formGroup">
    <ng-container formArrayName="models">
      <div *ngIf="index > 0" class="c-form--d c-form__section -full-width">
        <div class="c-form--d c-form__section-splitter">
          <div class="-splitter-body"></div>
        </div>
      </div>
      <span class="title"> <span i18n="@@common.model">Model</span> {{ index + 1 }} </span>
      <div class="row py-1" [formGroupName]="index">
        <div class="c-form__section col-6">
          <p500-ui-select-field
            [data]="models"
            formControlName="referralPayoutModel"
            i18n-label="@@common.referral_payout_model"
            label="Referral Payout Model"
          >
            <ng-template p500UIFieldTemplate let-data="data">
              {{ data.value.name }}
            </ng-template>
          </p500-ui-select-field>
        </div>
        <div class="c-form__section col-5">
          <gtd-text-with-hint
            formControlName="payoutModelValue"
            i18n-label="@@common.referral_payout"
            label="Referral Payout"
            [hintModal]="true"
            [tooltipHint]="modalTooltipEnum.REFERRAL_PROGRAM_PAYOUT"
          ></gtd-text-with-hint>
        </div>
        <div *ngIf="index > 0" class="c-form__section col-1">
          <div class="d-flex flex-column justify-content-end h100">
            <button
              p500-ui-circled-button
              size="small"
              type="button"
              color="warn"
              class="mb-6"
              [transparent]="true"
              (click)="removeModel(index)"
            >
              <p500-ui-icon name="close"></p500-ui-icon>
            </button>
          </div>
        </div>
        <div class="c-form__section col-12 d-flex">
          <span class="mr-10" i18n="@@common.add_condition">Add condition</span>
          <button p500-ui-circled-button size="small" color="primary" type="button" (click)="addConditions(index)">
            <p500-ui-icon name="plus"></p500-ui-icon>
          </button>
        </div>
        <div
          *ngIf="formGroup.controls.models.at(index).controls.conditions as conditionsControls"
          class="c-conditions c-conditions--d col-12"
        >
          <div *ngIf="conditionsControls.length > 0" class="c-conditions__groups-conditions c-form c-form--d">
            <p500-ui-preset-condition
              *ngFor="let control of conditionsControls.controls; let i = index"
              [index]="i"
              [formControl]="control"
              [name]="'pqlScheme'"
              [conditions]="conditions"
              [getValueComponentByType]="presetHelpers.getValueComponentByType"
              [getSignsData]="presetHelpers.getSignsDataPql"
              (remove)="removeCondition($event, index)"
              [hiddenOptions$]="hiddenOptionsList[index]"
              class="c-conditions__condition c-form__section"
            >
            </p500-ui-preset-condition>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-template>
